'use client'

import { WishlistHeadingDS } from '@src/components/blocks/wishlist-heading-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { WishlistShareSectionProps } from '../wishlist-share-section/wishlist-share-section'

import WishlistHeadingLegacy from './wishlist-heading-legacy'

type PropType = {
  name?: string
  isSelfWishlist?: boolean
} & Pick<WishlistShareSectionProps, 'wishListProductList'>

function WishlistHeading(props: PropType) {
  if (shouldUseDesignSystem()) {
    return <WishlistHeadingDS {...props} />
  }
  return <WishlistHeadingLegacy {...props} />
}

export default WishlistHeading
